/* Publish by EComposer at 2026-10-16 07:08:45*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vjx0fo7f82j"]=  window.__ectimmers["ecom-vjx0fo7f82j"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),s=this.settings.action;function o(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var p;(p=d.ec_splide)==null||p.refresh()})},50),r())}e.forEach((a,l)=>{s==="click"||window.screen.width<1025?a.onclick=()=>o(a,l):a.onmouseover=()=>o(a,l)});function n(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let m=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,m)}}}setTimeout(()=>{n()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",n,!1)

                    });
                    
                        document.querySelectorAll('.ecom-vjx0fo7f82j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vjx0fo7f82j', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cgb1ui4h1th"]=  window.__ectimmers["ecom-cgb1ui4h1th"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-cgb1ui4h1th').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cgb1ui4h1th', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8mgqp80p5ei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8mgqp80p5ei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o8gvr36jojd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o8gvr36jojd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8n8fnxh4vyg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8n8fnxh4vyg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ryz0dbvcymg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ryz0dbvcymg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-og98t2edpw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-og98t2edpw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sscogak6tv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sscogak6tv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r71njz4ykpt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r71njz4ykpt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ldrncjaqujk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ldrncjaqujk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2hmdiresf27').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2hmdiresf27', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vt0gqiq0lcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vt0gqiq0lcj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tdvevdrkwyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tdvevdrkwyh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-afgfc3ybya6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-afgfc3ybya6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cgfs1nfldlt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cgfs1nfldlt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ry3sht3lu9q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ry3sht3lu9q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lf8uglzsxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lf8uglzsxm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ehd4upz87q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ehd4upz87q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdbqrro6c7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdbqrro6c7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-km9h7hjy3ab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-km9h7hjy3ab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vtfrpep5nyg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vtfrpep5nyg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hgkts1om01n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hgkts1om01n', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-z2uz5etncgb"]=  window.__ectimmers["ecom-z2uz5etncgb"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-z2uz5etncgb"]["cqld329xn"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-z2uz5etncgb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z2uz5etncgb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lgwtzk7jeg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lgwtzk7jeg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pef340mh5fa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pef340mh5fa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tvp69tb8elg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tvp69tb8elg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tz0xe9uknla').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tz0xe9uknla', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5236iem5ml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5236iem5ml', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zfdd39u01z8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zfdd39u01z8', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ija9u3aeqz"]=  window.__ectimmers["ecom-ija9u3aeqz"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-ija9u3aeqz"]["2s39v7jf3"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-ija9u3aeqz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ija9u3aeqz', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4d26qahrha9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4d26qahrha9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1dgxfsatu1z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1dgxfsatu1z', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pap2lxx3n78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pap2lxx3n78', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u140x6pjemp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u140x6pjemp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4v2u5jw2sak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4v2u5jw2sak', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rec0bcurffi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rec0bcurffi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r36nk546urm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r36nk546urm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-54oiy5uj7dq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-54oiy5uj7dq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bpzxz008asv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bpzxz008asv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qjrhyyw0oo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qjrhyyw0oo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e01kkua7iuc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e01kkua7iuc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}